import React from "react";
import { withRouter } from 'react-router-dom';
import StandardFormComponent from "../../basics/form/StandardFormComponent";
import FormToastComponent from "../../basics/FormToastComponent";
import FormHelper from "../../../helpers/FormHelper";
import { LoaderComponent } from "../../basics/layout";
import EventOption from "../../../models/event/EventOption";
import { EventOptionGroupRepository, EventOptionRepository } from "../../../repository";
import OptionTextFormComponent from "./forms/OptionTextFormComponent";

class OptionFormComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            model: new EventOption(),
            group: null,
            loading: true
        };

        this.table_ref = React.createRef();
    }

    componentDidMount() {
        Promise.all([
            this.props.get_promise || Promise.resolve(null),
            EventOptionGroupRepository.get(this.props.match.params.group, this.props.match.params.event)
        ]).then(([option, group]) => this.setState({ loading: false, model: option || this.state.model, group: group }));
    }

    // "Max. quantity" only applies to a group with multiple choices
    useQuantity = () => this.state.group && !this.state.group.isSingle();

    success = () => {
        FormToastComponent.successTrans("Event", "Default.saved");
        this.props.history.push('/module/events/' + this.props.match.params.module + '/options/' + this.props.match.params.event + '/' + this.props.match.params.group + '/overview');
    }

    render() {
        if (this.state.loading) return <LoaderComponent />;

        return (
            <StandardFormComponent
                {...this.props}
                ref={this.table_ref}
                parent={this}
                className="event-option"
                validationSchema={EventOption.schema({ quantity: this.useQuantity() })}
                model={this.state.model}
                formSubmit={(values) => {
                    let data = {
                        event: this.props.match.params.event,
                        group: this.props.match.params.group,
                        title: values.title,
                        description: values.description,
                        active: !!values.active,
                        price: String(values.price).replace(/,/g, '.'),
                        price_type: values.price_type,
                        max_quantity: this.useQuantity() ? (parseInt(values.max_quantity) || 1) : 1,
                        is_default: !!values.is_default
                    };

                    let promise = this.state.model.id
                        ? EventOptionRepository.update({ ...data, id: this.state.model.id, language: this.props.match.params.language })
                        : EventOptionRepository.create(data);

                    return promise
                        .then(this.success)
                        .catch(error => FormHelper.handleSubmitError(this, error));
                }}
                formErrors={this.state.form_errors}
                fields={OptionTextFormComponent.fields({ quantity: this.useQuantity() })}
            />
        );
    }
}

export default withRouter(OptionFormComponent);
